/**
 *
 * jQuery Pubsub Model
 *
 * This is a simple jQuery pubsub that utilizes their trigger events
 * not as robust as the JS class in the utilities
 *
 */

const $ = require( 'jquery' );


(function($) {
    var o = $( {} );
    $.each({
        on: 'subscribe',
        trigger: 'publish',
        off: 'unsubscribe'
    }, function( key, api ) {
        $[api] = function() {
            o[key].apply( o, arguments );
        }
    });
})($);
